import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Count } from '~/components/count';
import { SearchBar } from '~/components/forms/search-bar';
import type { DataItemCellSelect__DataSourceListed as DataSourceListed } from '../DataItemCellSelect.generated';
import { FlexSpaceBetween, InlineFlex, SkinnySelect } from '../lib';

export interface DataItemCellSelectToolbarProps {
  dataSources: ReadonlyArray<DataSourceListed>;
  onSearch: (search: string) => void;
  onSourceSelect: (id: number) => void;
  rowCount: number;
  search: string;
  selectedSourceId: number | null;
}

export const DataItemCellSelectToolbar = ({
  dataSources,
  onSearch,
  onSourceSelect,
  rowCount,
  search,
  selectedSourceId,
}: DataItemCellSelectToolbarProps) => {
  const { t } = useTranslation();
  return (
    <FlexSpaceBetween>
      <InlineFlex>
        <SkinnySelect
          fullWidth
          onChange={(event) => onSourceSelect(Number(event.target.value))}
          value={selectedSourceId || ''}
        >
          {dataSources.map(({ id, name }) => (
            <MenuItem key={id} value={id}>
              {name}
            </MenuItem>
          ))}
        </SkinnySelect>
        <SearchBar
          onChange={onSearch}
          placeholder={t('pages.data_sources.edit.search_placeholder')}
          search={search}
          sx={{ minWidth: '250px' }}
        />
      </InlineFlex>
      <Count
        selectedCount={0}
        totalCount={rowCount}
        thing="components.data_item_cell_select.dialog.row_plural"
        sx={{ justifySelf: 'flex-end' }}
      />
    </FlexSpaceBetween>
  );
};
